import React from 'react';
import PlaceholderPage from '../components/PlaceholderPage';

const Notices = () => <PlaceholderPage title="공지사항" description="회원에게 보낼 공지사항을 관리해요." />;

export default Notices;
